var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"plex-image",style:({
    '--width': _vm.width + 'px',
    '--height': _vm.height + 'px',
        borderRadius: _vm.rounding,
})},[(_vm.glow)?_c('glow-image',{staticClass:"vimg",attrs:{"rounding":_vm.rounding,"width":_vm.width,"height":_vm.height,"src":_vm.fullSrc}}):_c('div',{staticClass:"vimg",style:({
        backgroundImage: ("url(" + _vm.fullSrc + ")"),
        borderRadius: _vm.rounding,
    })})],1)}
var staticRenderFns = []

export { render, staticRenderFns }